import classnames from 'classnames/bind'
import React from 'react'

import ArticleItem, { ArticleItemProps } from '~/components/ArticleItem'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ArticleLineProps {
  className?: string
  items?: ArticleItemProps[]
}

function ArticleLine({ className, items }: ArticleLineProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <div className={cx(css.ArticleLine, className)}>
      <div className={gridStyle}>
        {items?.map((item, index) => (
          <ArticleItem
            className={css.article}
            key={`article_push${index}`}
            {...item}
          />
        ))}
      </div>
    </div>
  )
}

ArticleLine.defaultProps = {}

export default ArticleLine
